import React from "react";
import ProfileListComponent from "@components/User/Profile/ProfileList/ProfileList";

export default function ProfileList() {
  return <ProfileListComponent />;
}
